import Vue from 'vue';
import {
	ValidationProvider, ValidationObserver, extend, localize,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import sk from './locales/sk';

Object.entries(rules).forEach(([rule, validation]: any) => {
	extend(rule, {
		...validation,
	});
});
localize('sk', sk);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
